<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 52.45 45.295"
  >
    <defs>
      <linearGradient id="linear-gradient" x1="0.691" y1="0.51" x2="0.208" y2="1.504" gradientUnits="objectBoundingBox">
        <stop offset="0" stop-color="#de4551" stop-opacity="0" />
        <stop offset="1" stop-color="#de4551" />
      </linearGradient>
      <linearGradient id="linear-gradient-2" x1="0" y1="0.5" x2="1" y2="0.5" xlink:href="#linear-gradient" />
    </defs>
    <g id="Group_177" data-name="Group 177" transform="translate(-467.82 55.626)">
      <path
        id="Path_683"
        data-name="Path 683"
        d="M505.193-54.124c-7.078-2.769-16.881-1.717-22.3,3.228-3.825,3.492-.864,4.487,1.743,10.876,1.887,4.624-16.818,3.988-16.818,12.344,0,9.66,13.548,7.829,18.575,8.935,7.687,1.691,14.393,8.015,22.605,7.181,7.15-.726,9.876-6.336,10.87-12.768,1.852-11.983-2.7-25.108-14.678-29.8Z"
        fill="url(#linear-gradient)"
      />
      <g id="Group_97" data-name="Group 97" transform="translate(474.483 -54.88)">
        <path
          id="Path_684"
          data-name="Path 684"
          d="M583.328,1.412l-3.466-3.068h0l-9.376-3.3L573.2-7.989a1.024,1.024,0,0,0-.764-1.707h-3.654v-7.626a1.024,1.024,0,0,0-1.024-1.024h-4.666a1.024,1.024,0,0,0-1.024,1.024V-9.7h-3.654a1.024,1.024,0,0,0-.764,1.707l2.712,3.034-9.376,3.3h0l-3.466,3.068a.512.512,0,0,0,.17.867l3.3,1.16V17.385a1.024,1.024,0,0,0,.684.966l13.416,4.72a1.024,1.024,0,0,0,.68,0l13.416-4.72a1.024,1.024,0,0,0,.684-.966V3.438l3.3-1.16a.512.512,0,0,0,.169-.867Z"
          transform="translate(-545.861 21.42)"
          opacity="0.1"
          fill="url(#linear-gradient-2)"
          style="isolation: isolate"
        />
        <g id="Group_95" data-name="Group 95" transform="translate(0.97 0)">
          <g id="Group_92" data-name="Group 92" transform="translate(4.151 0.512)">
            <g id="Group_85" data-name="Group 85" transform="translate(0 11.61)">
              <path
                id="Path_685"
                data-name="Path 685"
                d="M611.74,119.583v19.041a1.024,1.024,0,0,1-.684.966L597.3,144.43l-13.756-4.839a1.024,1.024,0,0,1-.684-.966V119.583Z"
                transform="translate(-582.86 -114.503)"
                fill="#fff"
              />
              <path
                id="Path_686"
                data-name="Path 686"
                d="M738.26,119.583v19.041a1.024,1.024,0,0,1-.684.966L723.82,144.43V119.583Z"
                transform="translate(-709.38 -114.503)"
                fill="#fff"
              />
              <g id="Group_84" data-name="Group 84" transform="translate(0.001 0)">
                <path
                  id="Path_687"
                  data-name="Path 687"
                  d="M597.3,69.99l-14.44,5.08,14.44,5.08,14.439-5.08Z"
                  transform="translate(-582.865 -69.99)"
                  fill="#f0324c"
                />
              </g>
            </g>
            <path
              id="Path_688"
              data-name="Path 688"
              d="M660.406-33.451h-3.654v10.7l-3.357,1.181-3.357-1.181v-10.7h-3.654a1.025,1.025,0,0,1-.764-1.708L652.63-43a1.025,1.025,0,0,1,1.528,0l7.011,7.844a1.025,1.025,0,0,1-.764,1.708Z"
              transform="translate(-638.955 43.345)"
              fill="#fff"
            />
            <g id="Group_86" data-name="Group 86" transform="translate(21.908 28.383)">
              <path
                id="Path_689"
                data-name="Path 689"
                d="M796.722,235.62v1.489a.512.512,0,0,0,.681.484l3.981-1.387a.512.512,0,0,0,.344-.484v-1.489a.512.512,0,0,0-.681-.484l-3.981,1.387a.512.512,0,0,0-.344.484Z"
                transform="translate(-796.722 -233.721)"
                fill="#f0324c"
              />
              <path
                id="Path_690"
                data-name="Path 690"
                d="M796.722,269.859v1.489a.512.512,0,0,0,.681.484l3.981-1.387a.512.512,0,0,0,.344-.484v-1.489a.512.512,0,0,0-.681-.484l-3.981,1.387A.512.512,0,0,0,796.722,269.859Z"
                transform="translate(-796.722 -264.452)"
                fill="#f0324c"
              />
            </g>
            <g id="Group_89" data-name="Group 89" transform="translate(1.829 28.381)">
              <g id="Group_87" data-name="Group 87">
                <path
                  id="Path_691"
                  data-name="Path 691"
                  d="M603.571,235.526a.508.508,0,0,1-.166-.028l-2.347-.8a.512.512,0,0,1,.331-.969l2.347.8a.512.512,0,0,1-.166,1Z"
                  transform="translate(-600.712 -233.7)"
                  fill="#2f3042"
                />
              </g>
              <g id="Group_88" data-name="Group 88" transform="translate(0 1.883)">
                <path
                  id="Path_692"
                  data-name="Path 692"
                  d="M603.571,253.906a.509.509,0,0,1-.166-.028l-2.347-.8a.512.512,0,0,1,.331-.969l2.347.8a.512.512,0,0,1-.166,1Z"
                  transform="translate(-600.712 -252.08)"
                  fill="#2f3042"
                />
              </g>
            </g>
            <g id="Group_91" data-name="Group 91" transform="translate(1.829 26.138)">
              <g id="Group_90" data-name="Group 90">
                <path
                  id="Path_693"
                  data-name="Path 693"
                  d="M607.226,214.88a.507.507,0,0,1-.165-.028l-6-2.049a.512.512,0,0,1,.331-.969l6,2.049a.512.512,0,0,1-.166,1Z"
                  transform="translate(-600.712 -211.807)"
                  fill="#2f3042"
                />
              </g>
            </g>
          </g>
          <g id="Group_93" data-name="Group 93" transform="translate(18.591 17.203)">
            <path
              id="Path_694"
              data-name="Path 694"
              d="M738.26,119.581l3.466,3.068a.512.512,0,0,1-.169.867l-13.334,4.691a.512.512,0,0,1-.51-.1l-3.893-3.446Z"
              transform="translate(-723.82 -119.581)"
              fill="#fff"
            />
          </g>
          <g id="Group_94" data-name="Group 94" transform="translate(0.513 17.203)">
            <path
              id="Path_695"
              data-name="Path 695"
              d="M550.981,119.581l-3.466,3.068a.512.512,0,0,0,.17.867l13.334,4.691a.512.512,0,0,0,.509-.1l3.893-3.446Z"
              transform="translate(-547.342 -119.581)"
              fill="#fff"
            />
          </g>
          <path
            id="Path_696"
            data-name="Path 696"
            d="M579.175-28.46l-3.466-3.068a.587.587,0,0,0-.17-.1L564.8-35.406v-2.023h3.142a1.519,1.519,0,0,0,1.4-.909,1.519,1.519,0,0,0-.257-1.651l-7.011-7.845a1.538,1.538,0,0,0-1.146-.513,1.538,1.538,0,0,0-1.146.513l-7.011,7.845a1.519,1.519,0,0,0-.257,1.651,1.519,1.519,0,0,0,1.4.909h3.142v2.023l-10.74,3.779a.585.585,0,0,0-.17.1l-3.466,3.068a1.015,1.015,0,0,0-.326.964,1.015,1.015,0,0,0,.665.77l2.954,1.039V-12.1A1.538,1.538,0,0,0,547-10.653L560.76-5.814a.512.512,0,0,0,.17.029.515.515,0,0,0,.17-.029l13.755-4.839a1.539,1.539,0,0,0,1.027-1.449V-25.687l2.954-1.039a1.014,1.014,0,0,0,.665-.77,1.014,1.014,0,0,0-.326-.964Zm-25.256-9.994a.5.5,0,0,1-.468-.3.5.5,0,0,1,.086-.55l7.011-7.845a.506.506,0,0,1,.382-.171.506.506,0,0,1,.382.171l7.011,7.845a.5.5,0,0,1,.086.55.5.5,0,0,1-.467.3h-3.654a.512.512,0,0,0-.512.512v7.653a.512.512,0,0,0,.512.512.512.512,0,0,0,.512-.512V-34.32l9.027,3.176-5.859,2.061-7.038,2.476-2.845-1V-37.941a.512.512,0,0,0-.512-.512Zm3.142,10.485-3.168-1.115-5.859-2.061,9.027-3.176Zm17.8,15.866a.513.513,0,0,1-.342.483L560.93-6.84,547.344-11.62A.513.513,0,0,1,547-12.1V-25.326l3.811,1.341a.512.512,0,0,0,.653-.313.512.512,0,0,0-.313-.653l-7.79-2.741,3.241-2.869,3.874,1.363,9.459,3.328L556.7-23l-2.668-.938a.512.512,0,0,0-.653.313.512.512,0,0,0,.313.653l2.668.938a1.022,1.022,0,0,0,.34.058,1.024,1.024,0,0,0,.679-.257l3.554-3.146,3.553,3.146a1.025,1.025,0,0,0,.68.257,1.022,1.022,0,0,0,.34-.058l9.355-3.291ZM565.162-23l-3.241-2.869,9.459-3.328,3.874-1.363,3.241,2.869Z"
            transform="translate(-542.339 48.347)"
            fill="#2f3042"
          />
        </g>
        <g id="Group_96" data-name="Group 96" transform="translate(0 8.034)">
          <path
            id="Path_697"
            data-name="Path 697"
            d="M548.3,32.079a.51.51,0,0,1-.362-.15l-.611-.611-.611.611A.512.512,0,0,1,546,31.2l.973-.973a.512.512,0,0,1,.724,0l.973.973a.512.512,0,0,1-.362.874Z"
            transform="translate(-544.517 -30.081)"
            fill="#f0324c"
          />
          <path
            id="Path_698"
            data-name="Path 698"
            d="M877.789,77.876a1.485,1.485,0,1,1,1.05-.434A1.48,1.48,0,0,1,877.789,77.876Zm0-1.945a.461.461,0,1,0,.326.135A.46.46,0,0,0,877.789,75.93Z"
            transform="translate(-841.123 -70.315)"
            fill="#f0324c"
          />
          <path
            id="Path_699"
            data-name="Path 699"
            d="M534.351,311.455a1.485,1.485,0,1,1,1.05-.434A1.48,1.48,0,0,1,534.351,311.455Zm0-1.945a.461.461,0,1,0,.326.135A.461.461,0,0,0,534.351,309.509Z"
            transform="translate(-532.867 -279.966)"
            fill="#f0324c"
          />
          <path
            id="Path_700"
            data-name="Path 700"
            d="M569.856,68.376a1.485,1.485,0,1,1,1.05-2.535h0a1.485,1.485,0,0,1-1.05,2.535Zm0-1.945a.461.461,0,1,0,.326.135.46.46,0,0,0-.326-.135Z"
            transform="translate(-564.734 -61.788)"
            fill="#f0324c"
          />
        </g>
      </g>
      <path
        id="Path_701"
        data-name="Path 701"
        d="M888.257,208.8a.51.51,0,0,1-.362-.15l-.611-.611-.611.611a.512.512,0,0,1-.724-.724l.973-.973a.512.512,0,0,1,.724,0l.973.973a.512.512,0,0,1-.362.874Z"
        transform="translate(-375.16 -235.549)"
        fill="#f0324c"
      />
      <path
        id="Path_702"
        data-name="Path 702"
        d="M718.82,171.065h1.024v19.573H718.82Z"
        transform="translate(-225.287 -203.469)"
        fill="#2f3042"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-12'
    },
    height: {
      type: String,
      default: 'h-12'
    }
  }
}
</script>
